const CUSTOMER_SUPPORT = 'Customer Support';
// Jira team page uses customer service while confluence team page uses customer support
const CUSTOMER_SERVICE = 'Customer Service';
const IT_SUPPORT = 'IT Support';
const FINANCE = 'Finance';
const HUMAN_RESOURCES = 'Human Resources';
const LEGAL = 'Legal';
const MARKETING = 'Marketing';
const OPERATIONS = 'Operations';
const SALES = 'Sales';
const SOFTWARE_DEVELOPMENT = 'Software Development';

const DESIGN = 'Design';
const RESEARCH = 'Research';
const PRODUCT_MANAGEMENT = 'Product Management';
const PROJECT_MANAGEMENT = 'Project Management';

const WHITEBOARD = 'whiteboard';
// These are the static templates mapping for each team type, we will be using this mapping for iteration 1 of this experiment
export const getTeamBasedTemplates = (teamType?: string, hasWhiteboard?: boolean) => {
	let templates;
	switch (teamType) {
		case CUSTOMER_SUPPORT:
		case CUSTOMER_SERVICE:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
			];
			break;
		case IT_SUPPORT:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
			];
			break;
		case FINANCE:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
			];
			break;
		case HUMAN_RESOURCES:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
			];
			break;
		case LEGAL:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
			];
			break;
		case MARKETING:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
			];
			break;
		case OPERATIONS:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
			];
			break;
		case SALES:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
			];
			break;
		case SOFTWARE_DEVELOPMENT:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:4-ls-retrospective-blueprint',
			];
			break;
		case DESIGN:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
			];
			break;
		case RESEARCH:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
			];
			break;
		case PROJECT_MANAGEMENT:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
			];
			break;
		case PRODUCT_MANAGEMENT:
			templates = [
				'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:productlaunch-blueprint',
			];
			break;
		default:
			templates = [
				'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
				'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
			];
	}
	if (hasWhiteboard) {
		templates[2] = WHITEBOARD;
	}
	return templates;
};
